import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[viFeatureGrid]',
})
export class ViFeatureGridDirective implements AfterViewInit {
  readonly largeScreenSizeBreakPoint = 1084;
  readonly smallScreenSizeBreakPoint = 576;

  gridContainer: any;
  maxColumnAmount: number;
  maxRowAmount: number;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.gridContainer = this.elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.init();
  }

  @HostListener('window:resize')
  init() {
    const gridContainerWidth = this.gridContainer.clientWidth;
    const gridContainerElements = this.gridContainer.children.length;

    if (gridContainerWidth > this.largeScreenSizeBreakPoint) {
      this.maxColumnAmount = 3;
    } else if (
      gridContainerWidth < this.largeScreenSizeBreakPoint &&
      gridContainerWidth > this.smallScreenSizeBreakPoint
    ) {
      this.maxColumnAmount = 2;
    } else {
      this.maxColumnAmount = 1;
    }

    this.maxRowAmount = Math.ceil(gridContainerElements / this.maxColumnAmount);

    this.renderer.setStyle(
      this.gridContainer,
      'grid-template',
      `repeat(${this.maxRowAmount}, 1fr) / repeat(${this.maxColumnAmount}, 1fr)`
    );
  }
}
